import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { TMM_URL } from 'toolkit/constants';

export const HEARTBEAT_INTERVAL_MS = 60000;

// Plain axios on purpose: a best-effort presence ping must never go through
// the tmmInstance 401 handling and log the customer out. `source` tells the
// backoffice which app the customer is online in.
const sendHeartbeat = (token) =>
  axios
    .post(`${TMM_URL}/stats/heartbeat`, null, {
      params: { source: 'forza' },
      headers: { Authorization: `Bearer ${token}`, 'app-key': 'forza-stack' }
    })
    .catch(() => {});

export default function useOnlineHeartbeat() {
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (!token) return undefined;

    const beat = () => {
      if (!document.hidden) sendHeartbeat(token);
    };

    beat();
    const intervalId = setInterval(beat, HEARTBEAT_INTERVAL_MS);
    document.addEventListener('visibilitychange', beat);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', beat);
    };
  }, [token]);
}
